import React from 'react';
import { useNavigate } from 'react-router-dom';

const items = [
  {
    title: 'Product Expertise',
    description: 'We carefully analyze project requirements and define clear objectives to ensure successful delivery.',
    image: '/assets/images/Team01.jpg',
    link: '/work'
  },
  {
    title: 'Customer Service',
    description: 'We can tailor waterproofing solutions to safeguard your property and prevent costly water damage.',
    image: '/assets/images/HSEC_CS.jpg',
    link: '/custom-services'
  }
];

const HowWeWork: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section id="how-we-work" className="py-2">
      <div className="container mx-auto px-4">
        <div 
          className="text-center mb-8"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">How We Work</h2>
          <div 
            className="w-24 h-1 bg-primary-light mx-auto mb-6 transform origin-left transition-transform duration-1000"
            data-aos="zoom-in"
            data-aos-delay="200"
          ></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto">
          {items.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-500 hover:shadow-xl cursor-pointer group"
              onClick={() => {
                navigate(item.link);
                window.scrollTo(0, 0);
              }}
              data-aos="fade-up"
              data-aos-delay={200 * (index + 1)}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              
              <div className="p-8 group-hover:bg-primary-light transition-colors duration-500">
                <h3 className="text-2xl font-bold text-gray-800 mb-4 group-hover:text-white transition-colors duration-500">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-lg group-hover:text-white/90 transition-colors duration-500">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;